module.exports = __webpack_public_path__ + "img/icon_service_info_map.30652319.png";